var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { Grid, GridItem, FlexJustifyContent, } from '../../common/components/Grid';
import RichContent from '../../common/components/RichText/RichContent';
var SeoSection = function (_a) {
    var content = _a.content, isContentCenterAligned = _a.isContentCenterAligned, isContentWithReducedWidth = _a.isContentWithReducedWidth, __legacy_shop_reboot_max_width = _a.__legacy_shop_reboot_max_width;
    return (React.createElement(Grid, __assign({ mb: [3, 4, null, 5], legacyShopRebootMaxWidth: __legacy_shop_reboot_max_width }, (isContentWithReducedWidth && {
        justifyContent: FlexJustifyContent.CENTER,
    }), { "data-testid": "seo-section-grid" }),
        React.createElement(GridItem, __assign({}, (isContentWithReducedWidth && { width: [1, 6 / 8, 8 / 12] })),
            React.createElement(RichContent, { content: content, isCenterAligned: isContentCenterAligned, "data-testid": "seo-section" }))));
};
SeoSection.defaultProps = {
    isContentCenterAligned: false,
    isContentWithReducedWidth: false,
    __legacy_shop_reboot_max_width: true,
};
export default SeoSection;
